import React from "react";
import Image from "components/imageNew/image";
import { SiftedLogoLoginFlow } from "./icons";

type Props = {
  externalSrc?: string | null;
  className?: string;
  alt?: string | null;
  width?: number;
  height?: number;
};

export const LoginFlowLogo: React.FC<Props> = ({
  externalSrc,
  className = "",
  alt = null,
  width,
  height,
}) => {
  const finalAlt = alt ?? "";

  return (
    <>
      {externalSrc && width && height ? (
        <Image
          src={externalSrc}
          alt={finalAlt}
          width={width}
          height={height}
          className={`${className} object-contain`}
          sizes={`${width}px`}
        />
      ) : (
        <SiftedLogoLoginFlow className={className} />
      )}
    </>
  );
};

export default LoginFlowLogo;
